export default __webpack_public_path__ + "img/7a62f33ecc03ee6d299b1966af9b5b5f.svg";